import React, { useState } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import PropTypes from "prop-types";
import {
  AvatarContainer,
  Column,
  DataColumn,
  Divider,
  RecognitionCard,
  RecognitionHeader,
  ScrollableContainer,
  TableRow,
  Title,
  ShowMore,
  NameInitials
} from "./styles";
import LazyImage from "../common/LazyImage/LazyImage";
import { ImageUrl } from "../../utils/constants";
import { getInitials } from "../../utils/methods";
import { DownloadReportIcon } from "../../utils/icons";


function RecognitionCommonCard({
  title,
  data,
  showMoreThreshold = 5,
  lastColumnName,
  setSelectedMember,
  setSelectedCard,
  cardType,
  setShowRecognitionPopUp,
  setShowReportPopUp
}) {
  const [showAllRows, setShowAllRows] = useState(false);
  const location = useLocation();
  const isDashboardRoute = location.pathname.includes("dashboard");

  const renderTableRows = () => {
    if (!data || data.length === 0) {
      return (
        <div id="recognition-common-no-data" style={{ textAlign: "center",color:"#184A61", marginTop: "16px" }}>
          No data available
        </div>
      );
    }

    const rowsToShow = showAllRows ? data : data.slice(0, showMoreThreshold);

    return rowsToShow.map((member, index) => (
      <React.Fragment key={index}>
        <TableRow id="recognition-common-row" isCursor={!isDashboardRoute  ? "pointer" : "default"}  isWidth={"574px"} onClick={!isDashboardRoute ? ()=>{setSelectedMember(member); setSelectedCard({type:cardType?.type,title:title,subtype:cardType?.subtype});setShowRecognitionPopUp(true)}: null }>
          <DataColumn id="recognition-common-data">
            <AvatarContainer isProfile={true} id="recognition-common-avatar">
              <DataColumn id="recognition-data-column">
                <AvatarContainer isProfile={true} id="recognition-common-profile">
                  {member?.profile_image !== "profile-Image/default.png" ? 
                    (<LazyImage
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "48px",
                        border: "1px solid #DCDCDC",
                      }}
                      onError={() => window.console.error("Image failed to load")}
                      src={`${ImageUrl}/${member?.profile_image}`}
                    />) :
                    (
                      <NameInitials id="recognition-name-initials">
                        {getInitials(member?.full_name)}
                      </NameInitials>
                    )}
                </AvatarContainer>
              </DataColumn>
            </AvatarContainer>
            {member?.full_name}
          </DataColumn>
          <DataColumn id="recognition-total-recognitions" isWidth={"260px"}>
            {member?.total_recognitions}
          </DataColumn>
        </TableRow>
        {index==4?<Divider id="recognition-divider" isMargin={"8px 0px"} />: index !== rowsToShow.length - 1 && <Divider isMargin={"8px 0px"} />}
      </React.Fragment>
    ));
  };

  return (
    <RecognitionCard height id="recognition-common-card">
      <div className="header" id="recognition-common-header">
        <Title id="recognition-common-title">{title}</Title>
        {!isDashboardRoute? <div id="recognition-common-icon" className="download-icon" onClick={()=>{setSelectedCard({type:cardType?.type,title:title,subtype:cardType?.subtype});setShowReportPopUp(true)}}>{DownloadReportIcon()}</div>: null}
      </div>
      <Divider isMargin={"0px"}/>
      <RecognitionHeader id="recognition-common-heading">
        <Column  id="recognition-common-employee">Employees</Column>
        <Column  id="recognition-gave-Received" isWidth={"301px"} isLast>{lastColumnName}</Column>
      </RecognitionHeader>
      <ScrollableContainer
        id="recognition-common-scrollable"
        showAllRows={showAllRows}
        height="380px"
      >
        {renderTableRows()}
        {data?.length > showMoreThreshold && !showAllRows && (
          <ShowMore
            id="recognition-common-show"
            onClick={() => setShowAllRows(true)}
            style={{
              cursor: "pointer",
              marginTop: "10px",
              textAlign: "center",
              color: "#184A61",
            }}
          >
            Show More
          </ShowMore>
        )}
      </ScrollableContainer>
    </RecognitionCard>
  );
}

RecognitionCommonCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      profile_image: PropTypes.string,
      full_name: PropTypes.string.isRequired,
      total_recognitions: PropTypes.number.isRequired,
    })
  ).isRequired,
  showMoreThreshold: PropTypes.number,
  lastColumnName: PropTypes.string,
  setSelectedCard: PropTypes.func,
  setSelectedMember: PropTypes.func,
  cardType: PropTypes.number,
  setShowRecognitionPopUp: PropTypes.func,
  setShowReportPopUp: PropTypes.func,
};

export default RecognitionCommonCard;
